import { Pipe, PipeTransform } from '@angular/core';

const IMAGE_MAP: Record<string, Record<string, Record<string, string>>> = {
  car: {
    Dirección: {
      Valor: 'details_car_direccion.png',
    },
    Estado_de_Actualización: {
      Actualizado: 'details_car_estado_actualizado.svg',
      Desactualizado: 'details_car_estado_desactualizado.svg',
      Sin_reporte: 'details_car_estado_sin_reporte.svg',
    },
    Estado_del_Vehiculo: {
      APAGADO: 'details_car_estado_vehiculo_apagado.png',
      MOVIENDO: 'details_car_estado_vehiculo_moviendo.png',
      ENCENDIDO: 'details_car_estado_vehiculo_encendido.png',
      DETENIDO: 'details_car_estado_vehiculo_detenido.png',
    },
    Última_Actualización: {
      Valor: 'details_car_ultima_actualizacion.png',
    },
    Coordenadas: {
      Valor: 'details_car_coordenadas.png',
    },
    Bloqueo: {
      SI: 'details_car_bloqueable.png',
      NO: 'details_car_no_bloqueable.png',
    },
    Subcuenta: {
      Valor: 'details_car_subcuenta.png',
    },
    Odómetro: {
      Valor: 'details_car_odometro.png',
    },
    Alias: {
      Valor: 'details_car_alias.png',
    },
  },
  
  engineers: {
    Dirección: {
      Valor: 'details_car_direccion.png',
    },
    Estado_de_Actualización: {
      Actualizado: 'details_car_estado_actualizado.svg',
      Desactualizado: 'details_car_estado_desactualizado.svg',
      Sin_reporte: 'details_car_estado_sin_reporte.svg',
    },
    Última_Actualización: {
      Valor: 'details_car_ultima_actualizacion.png',
    },
    Coordenadas: {
      Valor: 'details_car_coordenadas.png',
    },
    Subcuenta: {
      Valor: 'details_car_subcuenta.png',
    },
  },

  generic: {
    Dirección: {
      Valor: 'details_car_direccion.png',
    },
    Estado_de_Actualización: {
      Actualizado: 'details_car_estado_actualizado.svg',
      Desactualizado: 'details_car_estado_desactualizado.svg',
      Sin_reporte: 'details_car_estado_sin_reporte.svg',
    },
    Estado_del_Vehiculo: {
      APAGADO: 'details_car_estado_vehiculo_apagado.png',
      MOVIENDO: 'details_car_estado_vehiculo_moviendo.png',
      ENCENDIDO: 'details_car_estado_vehiculo_encendido.png',
      DETENIDO: 'details_car_estado_vehiculo_detenido.png',
    },
    Última_Actualización: {
      Valor: 'details_car_ultima_actualizacion.png',
    },
    Coordenadas: {
      Valor: 'details_car_coordenadas.png',
    },
    Bloqueo: {
      SI: 'details_car_bloqueable.png',
      NO: 'details_car_no_bloqueable.png',
    },
    Subcuenta: {
      Valor: 'details_car_subcuenta.png',
    },
    Odómetro: {
      Valor: 'details_car_odometro.png',
    },
    Alias: {
      Valor: 'details_car_alias.png',
    },
  },
};

@Pipe({ name: 'detailsIcons' })
export class DetailsIconsPipe implements PipeTransform {
  transform(category: string, property: string, value: string): string {
    if (!category || !property || !value) {
      return 'detail_Default.svg';
    }
    const normalizedValue = value.replace(/\s/g, '_');
    return IMAGE_MAP[category]?.[property]?.[normalizedValue] || 'detail_Default.svg';
  }
}